var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 8.5 11.6",
    style: {
      enableBackground: "new 0 0 8.5 11.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D60000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.5,10.1C3.6,10.1,3.6,10.1,3.5,10.1c0.2,0,0.4-0.2,0.4-0.4V5.3C4,5,3.8,4.8,3.5,4.8C3.3,4.8,3.1,5,3.1,5.2 v4.4C3.1,9.9,3.3,10.1,3.5,10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,10.1C5,10.1,5,10.1,5,10.1c0.2,0,0.4-0.2,0.4-0.4V5.3C5.4,5,5.3,4.8,5,4.8C4.8,4.8,4.6,5,4.6,5.2v4.4 c0,0.1,0.1,0.2,0.1,0.3C4.8,10,4.9,10.1,5,10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.3,2.9L8.3,2.9L8.3,2.9L6.5,2.2L6.6,2c0.2-0.4,0-0.9-0.5-1.1L3.9,0.1C3.5-0.1,3,0.1,2.9,0.5L2.8,0.7L1,0l0,0 C0.9,0,0.7,0,0.6,0c-0.1,0-0.2,0.1-0.2,0.2c-0.1,0.2,0,0.5,0.3,0.5L7,3.3l1,0.4c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0 c0.1,0,0.2-0.1,0.2-0.2C8.5,3.2,8.5,3,8.3,2.9z M5.8,1.7L5.7,1.9L3.5,1l0.1-0.2L5.8,1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,4.4l0.2,6.3c0,0.5,0.4,0.8,0.8,0.8h5.1c0.5,0,0.8-0.4,0.8-0.8l0.2-6.2h0l0-0.9H0V4.4z M6.1,10.7L6.1,10.7 l-5.1,0c0,0,0,0,0,0L0.8,4.5h5.4L6.1,10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.1,10.1C2.1,10.1,2.1,10.1,2.1,10.1c0.2,0,0.4-0.2,0.4-0.4V5.3c0-0.2-0.2-0.4-0.4-0.4C2,4.8,1.9,4.9,1.8,5 C1.7,5,1.7,5.1,1.7,5.2v4.4c0,0.1,0.1,0.2,0.1,0.3C1.9,10,2,10.1,2.1,10.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.9938ed78199cd4663ceeb43924c7084e.svg";
export { ForwardRef as ReactComponent };